module.exports = __webpack_public_path__ + "img/LTS_IIA.e075cad2.gif";